var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 11.5463C-0.0976311 11.1558 -0.0976311 10.5226 0.292893 10.1321L8.41635 2.00866H1.01157C0.459283 2.00866 0.0115677 1.56094 0.0115677 1.00866C0.0115677 0.456373 0.459283 0.00865739 1.01157 0.00865739L10.7075 0.00865735C10.7949 -0.00288579 10.8835 -0.00288578 10.9709 0.00865736L11.0116 0.00865739C11.5639 0.00865739 12.0116 0.456373 12.0116 1.00866V11.0087C12.0116 11.5609 11.5639 12.0087 11.0116 12.0087C10.4593 12.0087 10.0116 11.5609 10.0116 11.0087V3.40337L1.78786 11.6271C1.39733 12.0176 0.76417 12.0176 0.373646 11.6271L0.292893 11.5463Z",
    fill: "#2B32EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external-link-icon.5736c438f0bff1a2010e4b728f35f51e.svg";
export { ForwardRef as ReactComponent };